<template>
  <div class="panel-group" v-if="property.conception">
    <div v-for="id in property.conception.works.length" :key="id">
      <Accordion :number="id">
        <span
          slot="header-title"
        >Bilan de la visite par ouvrage n° {{ id }} - {{ getTypeOfWork(property.conception.works[id - 1].typeOfWork)}}</span>
        <span slot="body">
          <h4>Description de l'ouvrage</h4>
          <div class="block">
            <b-form-group label="Type" label-cols="4" label-for="typeOfWork">
              <b-form-input
                id="typeOfWork"
                name="typeOfWork"
                type="text"
                :maxlength="$MAX_255"
                :value="getTypeOfWork(property.conception.works[id - 1].typeOfWork)"
                disabled
              />
            </b-form-group>

            <b-form-group label="Régulation" label-cols="4" label-for="regulation">
              <b-form-input
                id="regulation"
                name="regulation"
                type="text"
                :maxlength="$MAX_255"
                :value="getControlOfWork(property.conception.works[id - 1].controlOfWork)"
                disabled
              />
            </b-form-group>
            <b-form-group label="Nombre" label-cols="4" label-for="number">
              <b-form-input
                id="number"
                name="number"
                type="text"
                step="1"
                :value="property.conception.works[id - 1].number"
                disabled
              />
            </b-form-group>

            <b-form-group label="Surface raccordée à l'ouvrage" label-cols="4" label-for="surface">
              <b-form-input
                id="surface"
                name="surface"
                type="text"
                :value="property.conception.works[id - 1].surface"
                disabled
              />
            </b-form-group>

            <b-form-group
              label="Surface active raccordée à l'ouvrage"
              label-cols="4"
              label-for="activeSurface"
            >
              <b-form-input
                id="activeSurface"
                name="activeSurface"
                type="text"
                :value="property.conception.works[id - 1].activeSurface"
                disabled
              />
            </b-form-group>
            <div role="group" class="form-row form-group">
              <label class="col-4 col-form-label">Débit de fuite prescrit pour cet ouvrage (L/s)</label>
              <div class="col">
                <b-form-input
                  id="leakFlowRate"
                  name="leakFlowRate"
                  type="number"
                  step=".01"
                  min="0"
                  :value="property.conception.works[id - 1].debit"
                  disabled
                />
              </div>
            </div>
            <b-form-group
              label="Débit de fuite constaté pour cet ouvrage (L/s) "
              label-cols="4"
              :label-for="'work' + id + '_debitNotice'"
            >
              <b-form-input
                :id="'work' + id + '_debitNotice'"
                :name="'work' + id + '_debitNotice'"
                class="form-control"
                v-model="getForm['work' + id + '_debitNotice']"
                rows="3"
                max-rows="6"
                type="number"
                step=".01"
                min="0"
              />
            </b-form-group>
            <div role="group" class="form-row form-group">
              <label class="col-4 col-form-label">Volume prescrit pour cet ouvrage (m³)</label>
              <div class="col">
                <b-form-input
                  id="rateVolume"
                  name="rateVolume"
                  type="number"
                  step=".01"
                  min="0"
                  :value="property.conception.works[id - 1].volume"
                  disabled
                />
              </div>
            </div>
            <b-form-group
              label="Volume constaté pour cet ouvrage (m³)"
              label-cols="4"
              :label-for="'work' + id + '_volumeNotice'"
            >
              <b-form-input
                :id="'work' + id + '_volumeNotice'"
                :name="'work' + id + '_volumeNotice'"
                class="form-control"
                v-model="getForm['work' + id + '_volumeNotice']"
                type="number"
                step=".01"
                min="0"
              />
            </b-form-group>
          </div>
          <hr />

          <h4>Liste des problèmes</h4>
          <div class="block">
            <b-form-group
              label="Problème d'accessibilité "
              label-cols="4"
              :label-for="'work' + id + '_accessibilityProblem'"
            >
              <b-form-radio-group
                :id="'work' + id + '_accessibilityProblem'"
                buttons
                v-model="getForm['work' + id + '_accessibilityProblem']"
                :options="options"
                size="lg"
                button-variant="outline-info"
                :name="'work' + id + '_accessibilityProblem'"
              />
            </b-form-group>

            <b-form-group
              label="Commentaires "
              label-cols="4"
              :label-for="'work' + id + '_commentAccessibilityProblem'"
            >
              <b-form-textarea
                :id="'work' + id + '_commentAccessibilityProblem'"
                :name="'work' + id + '_commentAccessibilityProblem'"
                class="form-control"
                v-model="getForm['work' + id + '_commentAccessibilityProblem']"
                rows="3"
                max-rows="6"
                :maxlength="$MAX_2000"
              />
            </b-form-group>

            <b-form-group
              label="Problème de fonctionnement "
              label-cols="4"
              :label-for="'work' + id + '_operationProblem'"
            >
              <b-form-radio-group
                :id="'work' + id + '_operationProblem'"
                buttons
                v-model="getForm['work' + id + '_operationProblem']"
                :options="options"
                size="lg"
                button-variant="outline-info"
                :name="'work' + id + '_operationProblem'"
              />
            </b-form-group>

            <b-form-group
              label="Commentaires "
              label-cols="4"
              :label-for="'work' + id + '_commentOperationProblem'"
            >
              <b-form-textarea
                :id="'work' + id + '_commentOperationProblem'"
                :name="'work' + id + '_commentOperationProblem'"
                class="form-control"
                v-model="getForm['work' + id + '_commentOperationProblem']"
                rows="3"
                max-rows="6"
                :maxlength="$MAX_2000"
              />
            </b-form-group>
            <template v-if="typeForm === typeVpt()">
              <SpecificWorkVpt :numberWork="id" />
            </template>
            <template v-if="typeForm === typeVe()">
              <SpecificWorkVe :numberWork="id" />
            </template>
          </div>
          <hr />
          <h4>Détails de l'ouvrage</h4>
          <div class="block">
            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_trapdoor'"
                  :name="'work' + id + '_trapdoor'"
                  v-model="getForm['work' + id + '_trapdoor']"
                  class="form-group row"
                  plain
                  value="1"
                  unchecked-value="null"
                >Trappes</b-form-checkbox>
              </b-col>
              <b-col sm="8" v-if="getForm['work' + id + '_trapdoor'] == 1">
                <b-row>
                  <b-col sm="4" class="text-center">
                    <b-form-group
                      label="Nombre trappes "
                      label-cols-md="5"
                      label-cols-sm="12"
                      label-size="lg"
                      :label-for="'work' + id + '_numberTrapdoor'"
                    >
                      <b-form-input
                        id="'work' + id + '_numberTrapdoor'"
                        :name="'work' + id + '_numberTrapdoor'"
                        type="text"
                        v-mask="'#########'"
                        size="sm"
                        class="form-control"
                        v-model="getForm['work' + id + '_numberTrapdoor']"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="8" class="row-maring">
                    <b-form-radio-group
                      :id="'work' + id + '_stateOfTrapdoor'"
                      buttons
                      size="lg"
                      stacked
                      class="btn-radio-lenght w-100"
                      v-model="getForm['work' + id + '_stateOfTrapdoor']"
                      :options="optionsTrapdoor"
                      button-variant="outline-info"
                      :name="'work' + id + '_stateOfTrapdoor'"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_stick'"
                  :name="'work' + id + '_stick'"
                  v-model="getForm['work' + id + '_stick']"
                  class="form-group row"
                  plain
                  value="1"
                  unchecked-value="null"
                >Cannes</b-form-checkbox>
              </b-col>
              <b-col sm="8" class="text-center" v-if="getForm['work' + id + '_stick'] == 1">
                <b-form-radio-group
                  :id="'work' + id + '_stateOfStick'"
                  buttons
                  v-model="getForm['work' + id + '_stateOfStick']"
                  :options="optionsState"
                  size="lg"
                  button-variant="outline-info"
                  :name="'work' + id + '_stateOfStick'"
                />
              </b-col>
            </b-row>
            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_scaleToApron'"
                  :name="'work' + id + '_scaleToApron'"
                  v-model="getForm['work' + id + '_scaleToApron']"
                  class="form-group row"
                  plain
                  value="1"
                  unchecked-value="null"
                >Echelons jusqu'au radier</b-form-checkbox>
              </b-col>
              <b-col sm="8" v-if="getForm['work' + id + '_scaleToApron'] == 1">
                <b-row>
                  <b-col sm="12" class="text-center">
                    <b-form-radio-group
                      :id="'work' + id + '_stateOfScaleToApron'"
                      buttons
                      v-model="getForm['work' + id + '_stateOfScaleToApron']"
                      :options="optionsState"
                      size="lg"
                      button-variant="outline-info"
                      :name="'work' + id + '_stateOfScaleToApron'"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-form-group
              label="Volume total (m3)"
              label-cols="4"
              :label-for="'work' + id + '_totalVolume'"
            >
              <b-form-input
                id="'work' + id + '_totalVolume'"
                :name="'work' + id + '_totalVolume'"
                type="number"
                step=".01"
                min="0"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_totalVolume']"
              />
            </b-form-group>

            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_overflow'"
                  :name="'work' + id + '_overflow'"
                  v-model="getForm['work' + id + '_overflow']"
                  class="form-group row"
                  plain
                  value="1"
                  unchecked-value="null"
                >Surverses</b-form-checkbox>
              </b-col>
              <b-col sm="8" v-if="getForm['work' + id + '_overflow'] == 1">
                <b-form-group
                  label="Hauteur (m) "
                  label-cols-md="2"
                  label-cols-sm="5"
                  label-size="md"
                  :label-for="'work' + id + '_height'"
                >
                  <b-form-input
                    id="'work' + id + '_overflowHeight'"
                    :name="'work' + id + '_overflowHeight'"
                    type="number"
                    step=".01"
                    min="0"
                    class="form-control"
                    v-model="getForm['work' + id + '_overflowHeight']"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_continuousWater'"
                  :name="'work' + id + '_continuousWater'"
                  v-model="getForm['work' + id + '_continuousWater']"
                  class="form-group row"
                  value="1"
                  unchecked-value="null"
                  plain
                >Eau permanente</b-form-checkbox>
              </b-col>
              <b-col sm="8" v-if="getForm['work' + id + '_continuousWater'] == 1">
                <b-form-group
                  label="Hauteur (m) "
                  label-cols-md="2"
                  label-cols-sm="5"
                  label-size="md"
                  :label-for="'work' + id + '_continuousWaterHeight'"
                >
                  <b-form-input
                    id="'work' + id + '_continuousWaterHeight'"
                    :name="'work' + id + '_continuousWaterHeight'"
                    type="number"
                    step=".01"
                    min="0"
                    class="form-control"
                    v-model="getForm['work' + id + '_continuousWaterHeight']"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="row-margin">
              <b-col sm="4">
                <b-form-checkbox
                  :id="'work' + id + '_warehouse'"
                  :name="'work' + id + '_warehouse'"
                  v-model="getForm['work' + id + '_warehouse']"
                  class="form-group row"
                  plain
                  value="1"
                  unchecked-value="null"
                >Dépôt</b-form-checkbox>
              </b-col>
              <b-col sm="8" v-if="getForm['work' + id + '_warehouse'] == 1">
                <b-form-group
                  label="Hauteur (m) "
                  label-cols-md="2"
                  label-cols-sm="5"
                  label-size="md"
                  :label-for="'work' + id + '_warehouseHight'"
                >
                  <b-form-input
                    id="'work' + id + '_warehouseHight'"
                    :name="'work' + id + '_warehouseHight'"
                    type="number"
                    step=".01"
                    min="0"
                    class="form-control"
                    v-model="getForm['work' + id + '_warehouseHight']"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-checkbox
              :id="'work' + id + '_presenceWasteWater'"
              :name="'work' + id + '_presenceWasteWater'"
              v-model="getForm['work' + id + '_presenceWasteWater']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
            >Présence EU</b-form-checkbox>
            <b-form-checkbox
              :id="'work' + id + '_presenceHydrocarbon'"
              :name="'work' + id + '_presenceHydrocarbon'"
              v-model="getForm['work' + id + '_presenceHydrocarbon']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
            >Présence hydrocarbure</b-form-checkbox>
            <b-form-checkbox
              :id="'work' + id + '_performedDescent'"
              :name="'work' + id + '_performedDescent'"
              v-model="getForm['work' + id + '_performedDescent']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
            >Descente effectuée</b-form-checkbox>

            <b-form-group
              label="Nombre d'arrivées "
              label-cols="4"
              :label-for="'work' + id + '_warehouseHight'"
            >
              <b-form-input
                id="'work' + id + '_numberArrival'"
                :name="'work' + id + '_numberArrival'"
                v-mask="'#########'"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_numberArrival']"
              />
            </b-form-group>
            <b-form-group
              label="Observations "
              label-cols="4"
              :label-for="'work' + id + '_observation'"
            >
              <b-form-textarea
                :id="'work' + id + '_observation'"
                :name="'work' + id + '_observation'"
                class="form-control"
                v-model="getForm['work' + id + '_observation']"
                rows="3"
                size="lg"
                max-rows="6"
                :maxlength="$MAX_2000"
              />
            </b-form-group>

            <b-form-group label="Régulation" label-cols="4" label-for="controlOfWork">
              <b-form-input
                id="controlOfWork"
                name="controlOfWork"
                type="text"
                class="form-control"
                :value="getControlOfWork(property.conception.works[id - 1].controlOfWork)"
                plain
                disabled
              />
            </b-form-group>

            <b-form-group
              label="Marque/Modèle "
              label-cols="4"
              :label-for="'work' + id + '_regulationModel'"
              v-if="![controlOfWorkInfiltration(), controlOfWorkCrapaudines()].includes(getControlOfWork(property.conception.works[id - 1].controlOfWork))"
            >
              <b-form-input
                id="'work' + id + '_regulationModel'"
                :name="'work' + id + '_regulationModel'"
                type="text"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_regulationModel']"
              />
            </b-form-group>

            <b-form-group
              label="Emplacement "
              label-cols="4"
              :label-for="'work' + id + '_regulationLocation'"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkPompes()"
            >
              <b-form-radio-group
                :id="'work' + id + '_regulationLocation'"
                buttons
                v-model="getForm['work' + id + '_regulationLocation']"
                :options="optionsLocation"
                size="lg"
                stacked
                button-variant="outline-info"
                :name="'work' + id + '_regulationLocation'"
                class="w-100"
              />
            </b-form-group>
            <b-form-group
              label="Nombre "
              label-cols="4"
              :label-for="'work' + id + '_regulationNumber'"
              v-if="[controlOfWorkCrapaudines(), controlOfWorkPompes()].includes(getControlOfWork(property.conception.works[id - 1].controlOfWork))"
            >
              <b-form-input
                id="'work' + id + '_regulationNumber'"
                :name="'work' + id + '_regulationNumber'"
                v-mask="'#########'"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_regulationNumber']"
              />
            </b-form-group>
            <b-form-group
              label="Hauteur Refoulement (m)"
              label-cols="4"
              :label-for="'work' + id + '_regulationDischargeHeight'"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkPompes()"
            >
              <b-form-input
                id="'work' + id + '_regulationDischargeHeight'"
                :name="'work' + id + '_regulationDischargeHeight'"
                type="number"
                step=".01"
                min="0"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_regulationDischargeHeight']"
              />
            </b-form-group>

            <b-form-checkbox
              :id="'work' + id + '_regulationRope'"
              :name="'work' + id + '_regulationRope'"
              v-model="getForm['work' + id + '_regulationRope']"
              v-if="[controlOfWorkVortex(), controlOfWorkSiphon(), controlOfWorkFlotteur()].includes(getControlOfWork(property.conception.works[id - 1].controlOfWork))"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
            >Elingue</b-form-checkbox>

            <b-form-group
              label="Diamètre"
              label-cols="4"
              :label-for="'work' + id + '_regulationDiameter'"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkOrifice()"
            >
              <b-form-input
                id="'work' + id + '_regulationDiameter'"
                :name="'work' + id + '_regulationDiameter'"
                type="number"
                step=".01"
                min="0"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_regulationDiameter']"
              />
            </b-form-group>

            <b-form-checkbox
              :id="'work' + id + '_regulationSluiceGate'"
              :name="'work' + id + '_regulationSluiceGate'"
              v-model="getForm['work' + id + '_regulationSluiceGate']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkOrifice()"
            >Vanne</b-form-checkbox>

            <b-form-checkbox
              :id="'work' + id + '_regulationOverflow'"
              :name="'work' + id + '_regulationOverflow'"
              v-model="getForm['work' + id + '_regulationOverflow']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkOrifice()"
            >Surverse</b-form-checkbox>

            <b-form-group
              label="Hauteur"
              label-cols="4"
              :label-for="'work' + id + '_regulationHeight'"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkCrapaudines()"
            >
              <b-form-input
                id="'work' + id + '_regulationHeight'"
                :name="'work' + id + '_regulationHeight'"
                type="number"
                step=".01"
                min="0"
                size="lg"
                class="form-control"
                v-model="getForm['work' + id + '_regulationHeight']"
              />
            </b-form-group>
            <b-form-checkbox
              :id="'work' + id + '_regulationEvacuationEquip'"
              :name="'work' + id + '_regulationEvacuationEquip'"
              v-model="getForm['work' + id + '_regulationEvacuationEquip']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) == controlOfWorkCrapaudines()"
            >Evacuations toutes équipées</b-form-checkbox>

            <b-form-checkbox
              :id="'work' + id + '_regulationOperation'"
              :name="'work' + id + '_regulationOperation'"
              v-model="getForm['work' + id + '_regulationOperation']"
              class="form-group row"
              plain
              value="1"
              unchecked-value="null"
              v-if="getControlOfWork(property.conception.works[id - 1].controlOfWork) != controlOfWorkInfiltration()"
            >Fonctionnement</b-form-checkbox>

            <b-form-group
              label="Entretien 'Rétention'  "
              label-cols="4"
              :label-for="'work' + id + '_evacuationMaintenanceRetention'"
            >
              <b-form-select
                v-model="getForm['work' + id + '_evacuationMaintenanceRetention']"
                :name="'work' + id + '_evacuationMaintenanceRetention'"
                :id="'work' + id + '_evacuationMaintenanceRetention'"
                :options="optionsMaintenaceRetention"
                plain
              >
                <template slot="first">
                  <option :value="null" disabled>-- Veuillez choisir une option --</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Entretien 'Régulation'  "
              label-cols="4"
              :label-for="'work' + id + '_evacuationMaintenanceControl'"
            >
              <b-form-select
                v-model="getForm['work' + id + '_evacuationMaintenanceControl']"
                :name="'work' + id + '_evacuationMaintenanceControl'"
                :id="'work' + id + '_evacuationMaintenanceControl'"
                :options="optionsMaintenaceControl"
                plain
              >
                <template slot="first">
                  <option :value="null" disabled>-- Veuillez choisir une option --</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="Observations"
              label-cols="4"
              :label-for="'work' + id + '_observationRegulation'"
            >
              <b-form-textarea
                :id="'work' + id + '_observationRegulation'"
                :name="'work' + id + '_observationRegulation'"
                v-model="getForm['work' + id + '_observationRegulation']"
                rows="3"
                size="lg"
                max-rows="6"
                :maxlength="$MAX_2000"
              />
            </b-form-group>
          </div>
        </span>
      </Accordion>
    </div>
  </div>
</template>

<script>
import Accordion from '../../Accordion';
import SpecificWorkVpt from './SpecificWorkVpt.vue';
import SpecificWorkVe from './SpecificWorkVe.vue';
import {
  TYPE_VPT,
  TYPE_VE,
  CONTROL_OF_WORK_POMPES,
  CONTROL_OF_WORK_VORTEX,
  CONTROL_OF_WORK_SIPHON,
  CONTROL_OF_WORK_FLOTTEUR,
  CONTROL_OF_WORK_ORIFICE,
  CONTROL_OF_WORK_CRAPAUDINES,
  CONTROL_OF_WORK_INFILTRATION
} from '../../../constants/params';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Works',
  components: {
    Accordion,
    SpecificWorkVpt,
    SpecificWorkVe,
  },
  computed: {
    ...mapState({ typeForm: state => state.app.typeForm, property: state => state.refProperties.property }),
    ...mapGetters(['getForm']),
  },
  methods: {
    limitDecimal: function(value, limit) {
      // limit + 1 because the "." chars count in the value length
      ++limit;
      if (value.indexOf('.') >= 0 && value.length - value.indexOf('.') > limit) {
        return value.slice(0, value.indexOf('.') + limit);
      }
      return value;
    },
    typeVpt: function() {
      return TYPE_VPT;
    },
    typeVe: function() {
      return TYPE_VE;
    },
    controlOfWorkPompes: function() {
      return CONTROL_OF_WORK_POMPES;
    },
    controlOfWorkVortex: function() {
      return CONTROL_OF_WORK_VORTEX;
    },
    controlOfWorkSiphon: function() {
      return CONTROL_OF_WORK_SIPHON;
    },
    controlOfWorkFlotteur: function() {
      return CONTROL_OF_WORK_FLOTTEUR;
    },
    controlOfWorkOrifice: function() {
      return CONTROL_OF_WORK_ORIFICE;
    },
    controlOfWorkCrapaudines: function() {
      return CONTROL_OF_WORK_CRAPAUDINES;
    },
    controlOfWorkInfiltration: function() {
      return CONTROL_OF_WORK_INFILTRATION;
    },
    getControlOfWork(value) {
      const options = [
        'Pompes',
        'Vortex',
        'Effet siphon',
        'A flotteur',
        'Orifice / Plaque',
        'Crapaudines',
        'Infiltration',
      ];
      return options[value];
    },
    getTypeOfWork(value) {
      const options = [
        'Bassin enterré avec casiers',
        "Bassin enterré en nid d'abeille",
        'Bassin enterré visitable',
        'Bassin ouvert en eau',
        'Bassin ouvert sec',
        'Canalisation surdimensionnée',
        'Cuve de réutilisation des eaux de pluies',
        'Noue Minérale',
        'Noue Végétalisée',
        "Puits d'infiltration non visitable",
        "Puits d'infiltration vide",
        "Puits d'infiltration visitable",
        'Toiture terasse minérale',
        'Toiture végétalisée extensive',
        'Toiture végétalisée intensive',
        'Toiture végétalisée semi-intensive',
        'Tranchée Drainante',
      ];
      return options[value];
    },
  },
  data: () => ({
    id: '',
    options: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Indéterminé', value: 'impossible' },
    ],
    optionsTrapdoor: [
      {
        value: 'good',
        text: 'Bon état',
      },
      {
        value: 'average',
        text: 'Etat moyen',
      },
      {
        value: 'bad',
        text: 'Mauvais état',
      },
      {
        value: 'difficult',
        text: 'Trappe lourde',
      },
    ],
    optionsState: [
      {
        value: 'good',
        text: 'Bon état',
      },
      {
        value: 'average',
        text: 'Etat moyen',
      },
      {
        value: 'bad',
        text: 'Mauvais état',
      },
    ],
    optionsLocation: [
      {
        value: 'put-on-apron',
        text: 'Posée(s) sur le radier',
      },
      {
        value: 'put-in-pit',
        text: 'Posée(s) dans une fosse',
      },
    ],
    optionsMaintenaceRetention: [
      {
        value: 'clean',
        text: 'Ouvrage propre',
      },
      {
        value: 'dirty-debri',
        text: 'Ouvrage encrassé - débris',
      },
      {
        value: 'dirty-floating',
        text: 'Ouvrage encrassé - flottants',
      },
      {
        value: 'blocked',
        text: 'Ouvrage saturé',
      },
    ],
    optionsMaintenaceControl: [
      {
        value: 'clean',
        text: 'Régulateur propre',
      },
      {
        value: 'dirty-debri',
        text: 'Régulateur encrassé - débris',
      },
      {
        value: 'dirty-floating',
        text: 'Régulateur encrassé - flottants',
      },
      {
        value: 'blocked',
        text: 'Régulateur bouché',
      },
    ],
  }),
};
</script>
